const TRUSTPILOT = 'https://trustpilot.com/review/expondo.com';
const REVIEW_COLLECTOR_TEMPLATE_ID = '56278e9abfbbba0bdcd568bc';

export {
  TRUSTPILOT,
  REVIEW_COLLECTOR_TEMPLATE_ID,
};
